import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import MaxSessionTime from './MaxSessionTime';

const mapStateToProps = (state: any) => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default withTranslation(['administration'])(connect(mapStateToProps, null)(MaxSessionTime));
